
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Mail, Send, Clock } from 'lucide-react';

const JobApplicationCTA = () => {
  const handleEmailClick = () => {
    window.location.href = 'mailto:raisa@afsprakenmaker.be?subject=Sollicitatie Sales Development Medewerker&body=Beste Raisa,%0D%0A%0D%0AIk ben geïnteresseerd in de vacature voor Sales Development Medewerker bij De Afsprakenmaker.%0D%0A%0D%0AIn bijlage vindt u mijn CV en een korte motivatie.%0D%0A%0D%0AMet vriendelijke groeten,%0D%0A[Uw naam]';
  };

  return (
    <section id="job-application" className="py-16 bg-brand-lightBlue/10">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Solliciteren? Dat kan eenvoudig!
          </h2>
          
          <Card className="bg-white shadow-lg border-brand-blue border-t-4">
            <CardHeader>
              <CardTitle className="flex items-center justify-center gap-2 text-brand-blue">
                <Mail className="h-6 w-6" />
                Stuur je sollicitatie
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <p className="text-lg text-gray-700">
                Mail je CV en korte motivatie naar:
              </p>
              
              <div className="bg-brand-lightBlue/20 p-4 rounded-lg">
                <p className="text-xl font-bold text-brand-blue">
                  raisa@afsprakenmaker.be
                </p>
              </div>
              
              <div className="grid md:grid-cols-2 gap-4">
                <Button 
                  size="lg" 
                  onClick={handleEmailClick}
                  className="bg-brand-red hover:bg-brand-red/90 text-white"
                >
                  <Send className="h-5 w-5 mr-2" />
                  Solliciteer nu
                </Button>
                
                <Button 
                  size="lg" 
                  variant="outline"
                  onClick={handleEmailClick}
                  className="border-brand-blue text-brand-blue hover:bg-brand-blue hover:text-white"
                >
                  <Mail className="h-5 w-5 mr-2" />
                  Mail Raisa
                </Button>
              </div>
              
              <div className="flex items-center justify-center gap-2 text-gray-600">
                <Clock className="h-5 w-5" />
                <span>We nemen snel contact met je op</span>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default JobApplicationCTA;
